import { useCallback, useEffect, useRef } from "react";
const useBlobUrl = (options = {})=>{
    const { multiple = false } = options;
    const urlsRef = useRef([]);
    useEffect(()=>()=>{
            urlsRef.current.forEach((url)=>URL.revokeObjectURL(url));
            urlsRef.current = [];
        }, []);
    const createUrl = useCallback((blob)=>{
        if (!multiple) {
            urlsRef.current.forEach((url)=>URL.revokeObjectURL(url));
            urlsRef.current = [];
        }
        const objectUrl = URL.createObjectURL(blob);
        urlsRef.current.push(objectUrl);
        return objectUrl;
    }, [
        multiple
    ]);
    const revokeUrl = useCallback(()=>{
        urlsRef.current.forEach((url)=>URL.revokeObjectURL(url));
        urlsRef.current = [];
    }, []);
    return {
        createUrl,
        revokeUrl
    };
};
export { useBlobUrl };
